<template>
  <section id="contato" class="section-shaped m-0 bg-default pt-0">
  <div class="container">
    <div class="row row-grid justify-content-center py-5">
      <h1 class="text-white">Contato</h1>
    </div>
    <div :style="{opacity: isLoading ? 0.92 : ''}" class="row  justify-content-center">
      <div class="col-lg-6 col-xl-8 col-md-10 col-sm-12">
        <card gradient="secondary" shadow body-classes="p-lg-5">
          <b-row v-if="isLoading" class="loading my-5" align-v="center">
            <b-col class="text-center">
              <spinner type="grow" size="md" variant="default"></spinner>
            </b-col>
          </b-row>
          <h4 class="mb-1">Fale Conosco</h4>
          <p class="text-muted mb-0">Escreva sua mensagem informando o motivo do contato.</p>
          <small class="text-muted pt-0"><span class="text-danger">*</span> Todos os campos são obrigatórios.</small>
          <b-form :validated="false" @submit.prevent="submit">
            <base-input
              class="mt-4"
              alternative
              v-model="form.model.nome"
              :error="form.inputs.nome.invalidFeedback"
              :valid="form.inputs.nome.state"
              placeholder="Seu nome"
              addon-left-icon="ni ni-user-run">
            </base-input>
            <base-input
              alternative
              v-model="form.model.email"
              :error="form.inputs.email.invalidFeedback"
              :valid="form.inputs.email.state"
              placeholder="Seu email"
              addon-left-icon="ni ni-email-83">
            </base-input>
            <base-input
              alternative
              v-model="form.model.assunto"
              :error="form.inputs.assunto.invalidFeedback"
              :valid="form.inputs.assunto.state"
              placeholder="Assunto"
              addon-left-icon="fa fa-question-circle ">
            </base-input>
            <base-input
              :error="form.inputs.mensagem.invalidFeedback"
              :valid="form.inputs.mensagem.state"
              class="mb-4">
                <textarea
                  v-model="form.model.mensagem"
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Sua mensagem ...">
                </textarea>
            </base-input>
            <button :disabled="isLoading" type="submit" class="btn btn-block mt-3 btn-primary">Enviar</button>
          </b-form>
        </card>
      </div>
    </div>
    <hr>
    <b-row class="justify-content-md-center mt-5 py-5">
      <b-col col lg="4" class="text-center mb-5">
        <h5 class="text-white font-weight-700">Contato:</h5>
        <i class="text-muted fa fa-phone-square"></i>
        <a href="tel:9132763898" target="_blank" class="ml-2 text-muted">(91) 3276-3898</a>
        <br>
        <a href="mailto: suporte@maiatecnologia.com.br" class="text-muted">suporte@maiatecnologia.com.br</a>
        <br>
        <a href="mailto: comercial@maiatecnologia.com.br" class="text-muted">comercial@maiatecnologia.com.br</a>
        <br>

        <div class="redes">
          <a href="https://www.instagram.com/maia.tecnologia/" target="_blank"><img src="./imagens_redes_sociais/instagram.png" alt=""></a>
          <a href="https://www.facebook.com/Maia.JanelaUnica" target="_blank"><img src="./imagens_redes_sociais/facebook.png" alt=""></a>
        </div>
        

      </b-col>
      <b-col lg="4" class="text-center mb-5">
        <h5 class="text-white font-weight-700">Maia Produção de Softwares LTDA</h5>
        <p class="text-muted">
          Controle de Arrecadação Municipal e Emissão de Notas Fiscais de Serviços Eletrônica
        </p>
      </b-col>
      <b-col col lg="4" class="text-center">
        <h5 class="text-white font-weight-700">Endereço:</h5>
        <i class="text-muted fa fa-map-marker"></i>
        <a class="text-muted" href="https://goo.gl/maps/aZiUyuzwZM33bP958" target="_blank">
          Tv. Barão do Triunfo, <br>
          3540A - Salas 813/815 <br>
          Marco - Belém-Pa
        </a>
      </b-col>
    </b-row>
  </div>
  </section>
</template>

<style>

  .redes{
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    gap: 2rem;
  }

</style>

<script>
  import Spinner from '../../components/Spinner'
  import { formMixin } from '../../mixins/formMixin'

  export default {
    name: 'section-contato',
    components: { Spinner },
    mixins: [ formMixin ],
    data() {
      return {
        year: new Date().getFullYear(),
        isLoading: false,
        form : {
          model: {
            nome: '',
            email: '',
            assunto:'',
            mensagem: ''
          },
          config: {
            apiUri: 'api/contato',
            httpMethod: 'post'
          },
          inputs: {
            nome: {
              type: 'text',
              state: null,
              invalidFeedback:''
            },
            email: {
              type: 'text',
              state: null,
              invalidFeedback:''
            },
            assunto: {
              type: 'password',
              state: null,
              invalidFeedback:''
            },
            mensagem: {
              type: 'password',
              state: null,
              invalidFeedback:''
            }
          }
        }
      }
    },
  }
</script>
